module.exports = __webpack_public_path__ + "static/media/minoan_text_04.87fd9a16.jpg";